import React, { FC } from "react";
import { Fab } from "@mui/material";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import SubtitlesOffOutlinedIcon from "@mui/icons-material/SubtitlesOffOutlined";

const SubtitlesButton: FC<{ on: boolean; onClick: () => void }> = ({
  on,
  onClick,
}) => {
  return (
    <Fab onClick={onClick} color="info" size="small">
      {on ? <SubtitlesOutlinedIcon /> : <SubtitlesOffOutlinedIcon />}
    </Fab>
  );
};

export default SubtitlesButton;
